// extracted by mini-css-extract-plugin
var _1 = "kG_eezXCrHdahZ3jTVp_";
var _2 = "sMG3H8p47gMOjBMtUVF_";
var _3 = "wmutaYip_3w2zYtGWCJH";
export { _1 as "backdrop", _2 as "heading", _3 as "wrapper" }
